<div *ngIf="statusLoading" class="status cust-select gts-sel prob-catg">
    <mat-icon *ngIf="splitIcon" class="material-icon media-material-icon status-icon"></mat-icon>
    <mat-form-field class="custom-mat-sel prob-catg-sel" [ngClass]="{'media-mat-sel': splitIcon}">
        <mat-select #selectopt panelClass="mat-bottom-panel" (openedChange)="openedChange($event)" placeholder="{{placeholder}}" [formControl]="statusFormControl" [(ngModel)]="dbSelectedStatus" [multiple]="multiple" disableOptionCentering>
            <div class="select-container multi-select-filter-widget" *ngIf="statusLoadingSelect">
                <mat-optgroup >
                    <mat-form-field style="width:100%;">
                        <input #search autocomplete="off" class="year-search-input" placeholder="{{searchPlaceholder}}" matInput [formControl]="statusSearchTextboxControl">
                        <button  *ngIf="search.value" matSuffix mat-icon-button aria-label="Clear" (click)="clearSearch($event)">
                        <mat-icon >close</mat-icon>
                        </button>
                    </mat-form-field>
                </mat-optgroup>
                <mat-optgroup *ngIf="(statusFilteredOptions | async).length == 0">
                    <div>No results found!</div>
                </mat-optgroup>
                <div *ngIf="selectClose" class="ngdialog-close" (click)="selectopt.close()">Close</div>
                <mat-option (onSelectionChange)="selectionChange($event)" *ngFor="let option of statusFilteredOptions | async" [value]="option" [disabled]="disableSelection(option)">
                {{option}}
                </mat-option>
            </div>
        </mat-select>
    </mat-form-field>
</div>
<div *ngIf="statusLoadingSelect">
    <div *ngIf="statusFormControl.value != ''" class="selected-items ps" [perfectScrollbar]="sconfig">
        <div *ngFor="let item of statusItems; let t=index" class="tag-text">
            <span>{{item}}</span>
            <i class="material-icons tag-close" (click)="disableTagSelection(t)">close</i>
        </div>
    </div>
</div>